import { ITienDoNhapDiemLopTinChiRequest } from "../../../model/request/tong-hop/ITienDoNhapDiemLopTinChiRequest";
import { ITienDoNhapDiemLopTinChiResponse } from "../../../model/response/tong-hop/ITienDoNhapDiemLopTinChiResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTienDoNhapDiemLopTinChiActionsObj = {
    THANH_PHAN_LOAD_START: {} as ITienDoNhapDiemLopTinChiRequest,
    THANH_PHAN_LOAD_SUCCESS: {} as ITienDoNhapDiemLopTinChiResponse[],
    THANH_PHAN_LOAD_ERROR: "",

    THI_LOAD_START: {} as ITienDoNhapDiemLopTinChiRequest,
    THI_LOAD_SUCCESS: {} as ITienDoNhapDiemLopTinChiResponse[],
    THI_LOAD_ERROR: "",   
}

export const eTienDoNhapDiemLopTinChiActionIds = generateActionTypeIds(eTienDoNhapDiemLopTinChiActionsObj, "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI");
export type ITienDoNhapDiemLopTinChiActionTypes = IGenericActionType<typeof eTienDoNhapDiemLopTinChiActionsObj, "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI">;